import React, { useEffect } from "react";
import "./LogoLoader.css";

import toptext from "../../media/aspenseparated/toptext.svg";
import middletext from "../../media/aspenseparated/middletext.svg";
import bottomtext from "../../media/aspenseparated/bottomtext.svg";
import circle from "../../media/aspenseparated/circle.svg";

const LogoLoader = ({ onLoaded }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof onLoaded === "function") {
        onLoaded(); // avoid error if onLoaded is not passed
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [onLoaded]);

  return (
    <div className="logo-loader-wrapper">
      <div className="logo-loader-box">
        <div className="logo-row">
          <img src={toptext} alt="Aspen SR" className="logo-toptext" />
          <img src={circle} alt="Graph Icon" className="logo-circle" />
        </div>
        <img
          src={middletext}
          alt="Business Solutions"
          className="logo-middletext"
        />
        <img src={bottomtext} alt="Services Line" className="logo-bottomtext" />
      </div>
    </div>
  );
};

LogoLoader.defaultProps = {
  onLoaded: () => {},
};

export default LogoLoader;
